"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
owa_bundling_1.preloadScriptChunk('FlexPane');
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FlexPane" */ './lazyIndex');
});
// Export actions
exports.lazyShowFlexPane = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.mountAndShowFlexPane; });
exports.lazyHideFlexPane = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.hideFlexPane; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-flex-pane/lib/index.js
// module id = 2681
// module chunks = 3 4 38 45 64 66